import { Application } from '../../Dashboard.types';
import styles from '../SpendingLimitCard.module.css';
import { tracking } from '@iwoca/frontend-tracking-library';
import refreshIconSvg from './refreshIcon.svg';
import refreshIconGreySvg from './refreshIconGrey.svg';
import classNames from 'classnames';
import { daysSinceStatusDate } from '../../Dashboard.helpers';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { GetBuyerSpendingLimitResponse } from '@iwoca/lapi-client/iwocapay';

export const DeclinedLimits = ({
    setIsSpendingLimitDrawerOpen,
    spendingLimit,
    loading,
    handleClick,
    application
}: {
    setIsSpendingLimitDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
    spendingLimit: GetBuyerSpendingLimitResponse['data']['active_spending_limit'];
    loading: boolean;
    handleClick: () => void;
    application: Application;
}) => {
    const daysSinceDecline = daysSinceStatusDate(application);

    // Don't let them refresh until 30 days after decline.
    // If we don't know how many days since decline, let them try
    const showRefreshButton =
        daysSinceDecline !== null ? daysSinceDecline >= 30 : true;
    return (
        <>
            <div className={styles.leftInnerContainer}>
                <div className={styles.remainingLimitHeader}>
                    You have{' '}
                    <FormattedCurrency
                        className={styles.remainingLimitAmount}
                        value={0}
                    />{' '}
                    left to spend
                </div>
                <div className={styles.interestRateLabel}>
                    We can’t approve you for more funds right now - check back
                    in 30 days and hit ‘Secure my limit’.
                </div>
            </div>
            <div className={styles.rightInnerContainer}>
                <div className={styles.spendingLimitAmount}>
                    <div>
                        Spending limit: <FormattedCurrency value={0} />
                    </div>
                    {showRefreshButton && (
                        <button
                            className={classNames(styles.secureLimitButton, {
                                [styles.secureLimitButtonDisabled]: loading
                            })}
                            onClick={() => handleClick()}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <img
                                        src={refreshIconGreySvg}
                                        className={styles.spinningIcon}
                                        alt=""
                                    />
                                    Checking limit...
                                </>
                            ) : (
                                <>
                                    <img src={refreshIconSvg} alt="" />
                                    Secure my limit
                                </>
                            )}
                        </button>
                    )}
                </div>
                <div className={styles.spendingLimitDurationLabel}>
                    {spendingLimit.duration_in_months} month purchases{' '}
                    <button
                        onClick={() => {
                            tracking.ampli.spendingLimitViewedOtherTerms();
                            setIsSpendingLimitDrawerOpen(true);
                        }}
                        className={styles.otherTermsButton}
                    >
                        Other terms
                    </button>
                </div>
            </div>
        </>
    );
};
